"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_breakpoints_1 = require("react-breakpoints");
var Header_1 = __importDefault(require("./Header"));
var Footer_1 = __importDefault(require("./Footer"));
function Layout(_a) {
    var breakpoints = _a.breakpoints, currentBreakpoint = _a.currentBreakpoint, children = _a.children;
    if (breakpoints[currentBreakpoint] >= breakpoints.large)
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(Header_1.default, null,
                react_1.default.createElement(Footer_1.default, null)),
            children));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Header_1.default, null),
        children,
        react_1.default.createElement(Footer_1.default, null)));
}
exports.default = (0, react_breakpoints_1.withBreakpoints)(Layout);
